module.exports = __webpack_public_path__ + "static/media/Xtra_Large_2.e560c42d.jpg";